import { images } from '@constants/images';
import useScreenSize from '@hooks/useScreenSize';
import { useSelector } from 'react-redux';
import { RootState } from '@utils/types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserDropdown from './user-dropdown';
import { HiOutlineMenu } from 'react-icons/hi';
import MobileMenu from './mobile-menu';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();
  const { t: translate } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { loungeId } = useSelector((state: RootState) => state.login);

  const isActive = (path: string) => {
    if (path.startsWith('/terms-conditions')) {
      return location.pathname.startsWith('/terms-conditions');
    }
    return location.pathname === path;
  };

  return isMobile ? (
    <header>
      <nav className="w-full bg-primary-0">
        <div className="flex justify-between px-2">
          <div className="flex items-center justify-start xl:hidden">
            <img
              src={images.newLogo}
              alt="Company Logo"
              className="h-[64px] w-[64px] pl-1"
            />
          </div>
          <button
            id="header-cta"
            className="flex items-center p-4 sm:col-span-6 lg:col-span-6 xl:gap-6"
            onClick={() => setIsMenuOpen(true)}
          >
            <HiOutlineMenu size={24} className="text-gray-800" />
          </button>
        </div>
      </nav>
      {isMenuOpen && (
        <MobileMenu onClose={() => setIsMenuOpen(false)} loungeId={loungeId} />
      )}
    </header>
  ) : (
    <header>
      <nav className="w-full bg-primary-0">
        <div className="flex justify-between">
          <button
            className="px-6 sm:hidden xl:block"
            onClick={() => navigate('/')}
          >
            <img
              src={images.newLogoSmall}
              alt="Company Logo"
              className="pl-1"
            />
          </button>
          <div
            id="header-cta"
            className="flex items-center p-4 sm:col-span-6 lg:col-span-6 xl:gap-6"
          >
            <Link
              className={`text-md font-normal ${isActive('/select-city') ? 'font-semibold text-blue-600' : ''}`}
              to="/select-city"
            >
              Book a Lounge
            </Link>
            <Link
              className={`text-md font-normal ${isActive('/my-bookings') ? 'font-semibold text-blue-600' : ''}`}
              to="/my-bookings"
            >
              My Bookings
            </Link>
            <Link
              to={`/terms-conditions?loungeId=${loungeId}`}
              className={`text-md font-normal ${isActive('/terms-conditions') ? 'font-semibold text-blue-600' : ''}`}
            >
              {translate('termsConditionsPage.heading')}
            </Link>
            <div className="flex items-center px-3 font-normal">
              <UserDropdown />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
